<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>问答库</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-select v-model="searchData.product" placeholder="请选择产品">
                            <el-option :label="item" :value="item" v-for="item in appData.product" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.lang" placeholder="请选择语言">
                            <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button button2 add" @click="$router.push({name: 'psc-faq-update'})" v-if="roleCheck('103-103-102-102')">
                            <span>编辑</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="tableData">
                <el-table-column label="产品" prop="product" width="120px"></el-table-column>
                <el-table-column label="语言" width="120px">
                    <template slot-scope="scope">
                        <span>{{ appData.lang[scope.row.lang] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="类型" prop="type" width="120px"></el-table-column>
                <el-table-column label="问题" prop="q"></el-table-column>
                <el-table-column label="回答" align="left">
                    <template slot-scope="scope" >
                        <p class="answer">{{ scope.row.a }}</p>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import aliOss from '../../../aliOss/index'
export default({
    name: 'psc-faq',
    data() {
        return {
            faqShow: false,
            searchData: {
                product: 'M1',
                lang: 'zh',
                type: ''
            },
            faqConfig: '',
            tableData: []
        }
    },
    watch: {
    },
    created() {
        this.getConfig();
    },
    methods: {
        getConfig() {
            aliOss.getFile('config.json').then(r => {
                this.faqConfig = JSON.parse(r.content);
                console.log(this.faqConfig)
                this.convertedTableData();
            })
        },
        search() {
            this.getConfig();
        },
        convertedTableData() {
            if(this.faqConfig[this.searchData.product] && this.faqConfig[this.searchData.product][this.searchData.lang] && this.faqConfig[this.searchData.product][this.searchData.lang].faq) {
                const convertedData = this.faqConfig[this.searchData.product][this.searchData.lang].faq;
                const faqArray = [];
                for (const category in convertedData) {
                    for (const item of convertedData[category]) {
                        const product = this.searchData.product;
                        const lang = this.searchData.lang;
                        const type = category;
                        const q = item.q;
                        const a = item.a;
                        faqArray.push({ product, lang, type, q, a });
                    }
                }
                this.tableData = faqArray;
            }else{
                this.tableData = [];
            }
            
        }
    }
})
</script>
<style lang="less" scoped>
    .answer{
        white-space: pre-wrap;
    }
    
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/faq.vue